export const DIY_STORE_ID = '10351';

// Cookies
export const GEO_LOCATION_COOKIE_NAME = 'geoLocationHDP';
export const DELIVERY_LOCATION_COOKIE_NAME = 'deliveryLocationHDP';
export const DELIVERY_MARKET_COOKIE_NAME = 'deliveryMarketHDP';
export const WC_MARKET_ID_COOKIE = `WC_MarketId_${DIY_STORE_ID}`;
export const WC_DEFAULT_STORE_COOKIE = `WC_DefaultStore_${DIY_STORE_ID}`;
export const WC_ST_FIND_COOKIE = 'WC_stFind';
export const WC_ST_PROV_COOKIE = 'WC_stProv';

export const SELECTED_PROFILE_STORAGE = 'HCS-HDM-B2C-Store-selectedProfile';
export const SELECTED_ADDRESS_STORAGE = 'HCS-HDM-B2C-Store-selectedAddress';

// storeconf userData key acting as the global kill switch for Adobe Target --
// gates the script injection in _document.tsx AND every Adobe Target
// view-tracking hook (useAdobeTargetPageView, useAdobeTargetComponentView,
// useAdobeTargetEntityView, useAdobeTargetCheckout). When 'false' or unset, no
// Adobe Target hook does any work, regardless of its own enabled flag.
export const ENABLE_ADOBE_SCRIPT_FLAG = 'ENABLE_ADOBE_SCRIPT_FLAG';

// storeconf userData key gating all Adobe Target view-tracking hooks --
// useAdobeTargetPageView, useAdobeTargetComponentView, useAdobeTargetEntityView,
// and useAdobeTargetCheckout. Does NOT gate the Adobe Target script injection
// itself (_document.tsx), which is controlled solely by ENABLE_ADOBE_SCRIPT_FLAG.
export const ADOBE_NOT_ALLOWED_PATH_LIST_KEY = 'ADOBE_NOT_ALLOWED_PATH_LIST';

// storeconf userData flags to independently turn on each Adobe Target
// view-tracking hook without a deploy. Disabled (no-op) until the storeconf
// value is created and set to 'true'.
export const ADOBE_TARGET_PAGE_VIEWS_ENABLED_KEY = 'ADOBE_TARGET_PAGE_VIEWS_ENABLED';
export const ADOBE_TARGET_COMPONENT_VIEWS_ENABLED_KEY = 'ADOBE_TARGET_COMPONENT_VIEWS_ENABLED';
export const ADOBE_TARGET_ENTITY_VIEWS_ENABLED_KEY = 'ADOBE_TARGET_ENTITY_VIEWS_ENABLED';

// Enables the React-based DiBot widget. When this userData flag is 'true', the
// legacy LIVE_CHATBOT <Script> injection in _document.tsx is skipped.
// The value is sourced either from HCL storeconf or, on local/dev, from the
// server env var ENABLE_DIBOT (injected into userData by the Settings fetcher).
export const ENABLE_DIBOT_REACT_FLAG = 'ENABLE_DIBOT_REACT';

// userData keys carrying the Microsoft Omnichannel connection config for the
// DiBot widget. Their values come from the server-only env vars
// DIBOT_OMNICHANNEL_ORG_URL / _ORG_ID / _WIDGET_ID, injected into userData by the
// Settings fetcher so the client can read them without a NEXT_PUBLIC_ prefix.
export const DIBOT_OMNICHANNEL_ORG_URL_KEY = 'DIBOT_OMNICHANNEL_ORG_URL';
export const DIBOT_OMNICHANNEL_ORG_ID_KEY = 'DIBOT_OMNICHANNEL_ORG_ID';
export const DIBOT_OMNICHANNEL_WIDGET_ID_KEY = 'DIBOT_OMNICHANNEL_WIDGET_ID';

// userData keys carrying the Microsoft Omnichannel connection config for the
// DiBot APP widget — a SEPARATE Copilot Studio project used by the mobile app
// webview (/dibot-chat). Their values come from the server-only env vars
// DIBOT_APP_OMNICHANNEL_ORG_URL / _ORG_ID / _WIDGET_ID, injected into userData
// by the Settings fetcher so the client can read them without a NEXT_PUBLIC_ prefix.
export const DIBOT_APP_OMNICHANNEL_ORG_URL_KEY = 'DIBOT_APP_OMNICHANNEL_ORG_URL';
export const DIBOT_APP_OMNICHANNEL_ORG_ID_KEY = 'DIBOT_APP_OMNICHANNEL_ORG_ID';
export const DIBOT_APP_OMNICHANNEL_WIDGET_ID_KEY = 'DIBOT_APP_OMNICHANNEL_WIDGET_ID';
// Master on/off switch for the DiBot reCAPTCHA gate, independent of whether
// DIBOT_RECAPTCHA_SITE_KEY is configured — lets ops disable the check quickly
// (e.g. during an incident) without touching credentials. Same pattern as
// ENABLE_DIBOT_REACT_FLAG: sourced from the local/dev env var ENABLE_DIBOT_RECAPTCHA,
// surfaced through userData. Defaults to disabled ('false'/unset) when missing.
export const ENABLE_DIBOT_RECAPTCHA_FLAG = 'ENABLE_DIBOT_RECAPTCHA';

// userData key carrying the reCAPTCHA Enterprise (score-based, invisible) site
// key checked silently before a DiBot session starts. Site keys are public
// client bootstrap values (not secrets — they're meant to be embedded in page
// markup), but are still kept as a server-only env var (DIBOT_RECAPTCHA_SITE_KEY)
// and surfaced through userData for consistency with the Omnichannel ids above.
// The matching API key/project id (and score threshold) used to verify tokens
// are read only server-side, in pages/api/dibot-recaptcha-verify.ts.
export const DIBOT_RECAPTCHA_SITE_KEY_KEY = 'DIBOT_RECAPTCHA_SITE_KEY';

// The reCAPTCHA `action` label sent by the client's execute() call and checked
// against `tokenProperties.action` server-side. Shared here so the two sides
// (useDibotRecaptcha.ts and dibot-recaptcha-verify.ts) can't drift apart.
export const DIBOT_RECAPTCHA_ACTION = 'CHAT_OPEN';

export const GEO_LOCATION_PERMISSION_GRANTED = 'granted';
export const GEO_LOCATION_PERMISSION_PROMPT = 'prompt';
export const MIN_EXP_TIME = 1;
export const MAX_EXP_TIME = 365;
export const MD_BREAKPOINT = 'md';
export const GOOGLE_MAP_URL = 'https://maps.google.com/?q=';
export const DEFAULT_STATE_ID = '11134';
export const DEFAULT_UNIQUE_ID = '12605';
export const DEFAULT_STORE_ID = '8702';
export const LOCALE_ES_MX = 'es-MX';
export const GOOGLE_RECAPTCHA_URL = 'https://www.google.com/recaptcha/enterprise.js?hl=es&render=';
export const CHECKOUT = 'checkout';
export const HCLSTORE_PATH = '/hclstore/HDM-CAS';
export const HD_BASE_URL = 'https://www.homedepot.com.mx';
export const CDN_BASE_URL = 'https://cdn.homedepot.com.mx';
export const STORE_LOCATOR_RADIUS = 100;
export const MATERIAL_SYMBOL_ICONS_LINK =
	'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
export const MATERIAL_SYMBOL_ICONS_OUTLINE_LINK =
	'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
export const MATERIAL_SYMBOL_ICONS_SHARP_LINK =
	'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp';
export const NO_IMAGE_PLACE_HOLDER =
	'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzAwJyBoZWlnaHQ9JzIwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cmVjdCB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyBmaWxsPScjZGRkJy8+PC9zdmc+';
export const ProductQuantityMeasures = {
	SQUARE_METER: 'MTK',
	METER: 'MTR',
	KILOGRAM: 'KGM',
	LITER: 'LTR',
	GENERIC: 'C62',
};
export const ProductWeightMeasures = {
	BOX: 'BX',
	LINEAR_METER: 'LM',
};
export const LIVE_CHATBOT = (el: Node, fallbackData: string[]) => {
	el.parentNode?.removeChild(el);
	const s = document.createElement('script');
	s.src = fallbackData[1];
	s.setAttribute('id', fallbackData[0]);
	s.setAttribute('data-app-id', fallbackData[2]);
	s.setAttribute('data-lcw-version', fallbackData[3]);
	s.setAttribute('data-org-id', fallbackData[4]);
	s.setAttribute('data-org-url', fallbackData[5]);
	document.body.appendChild(s);
};
export const SCARAB_SCRIPT = `
var ScarabQueue = ScarabQueue || [];
(function (id) {
    if (document.getElementById(id)) return;
    var js = document.createElement('script'); js.id = id;
    js.src = '//cdn.scarabresearch.com/js/111DA9884C50600F/scarab-v2.js';
    var fs = document.getElementsByTagName('script')[0];
    fs.parentNode.insertBefore(js, fs);
  })('scarab-js-api');
  `;
export const SCARAB_SCRIPT_URL = '//cdn.scarabresearch.com/js/111DA9884C50600F/scarab-v2.js';

// Emarsys profile
export const SEARCH_EMARSYS_PROFILE_DEFAULT = 'HDM_findProductsByPartNumberEmarsysCarousel';

// Storeconfs
export const ENABLE_EMARSYS_IDENTIFIER_FIELD = 'ENABLE_EMARSYS_IDENTIFIER_FIELD';
export const ENABLE_EMARSYS_TEST_MODE = 'ENABLE_EMARSYS_TEST_MODE';
export const ENABLE_SEO_LINKS_HOMEPAGE = 'ENABLE_SEO_LINKS_HOMEPAGE';
// This flag is to enable/disable the quick win for checkout profiles
export const ENABLE_AUTO_SELECT_CHECKOUT_PROFILE = 'ENABLE_AUTO_SELECT_CHECKOUT_PROFILE';
export const ENABLE_QUICK_BUY = 'ENABLE_QUICK_BUY';

export const AUTOMATIC_CLOSED_STORE_HOLIDAYS = 'AUTOMATIC_CLOSED_STORE_HOLIDAYS';

// Common
export const CHILD_ROUTE_SEPARATOR = '/';

export enum PRODUCT_FEATURE {
	TECHNICAL_VISIT = 'TV',
	SERVICE_INSTALLATION = 'SI',
}

export const WISH_LIST_DEFAULT = 'Mis favoritos';

export const downloadFiles = [
	{
		order: '1',
		type: 'Garantía',
		fileName: `-g.pdf`,
		id: 'downloadWarrantyLink',
	},
	{
		order: '2',
		type: 'Manual de usuario',
		fileName: `-m.pdf`,
		id: 'downloadUserManualLink',
	},
	{
		order: '3',
		type: 'Especificaciones Técnicas',
		fileName: `-e.pdf`,
		id: 'downloadSpecsLink',
	},
];

export const OpenSansFontWeights = {
	light: 300,
	regular: 400,
	semibold: 600,
	bold: 700,
};

export const HelveticaNeue_THDFontWeights = {
	heavy: 400,
	black: 600,
};

export const paintCodeTransparentD = 'D';
export const paintCodeTransparentM = 'M';
export const paintCodeWhite = 'B';
export const paintCodeUltraWhite = 'U';

export const PREMIUM_BASE_PAINTS = [paintCodeUltraWhite, paintCodeWhite];
export const TRANSPARENT_BASE_PAINTS = [paintCodeTransparentD, paintCodeTransparentM];
export const NOT_APLICABLE_BASE = 'N/A';
export const BASE_IDENTIFIER_WORDING = 'BASE';
export const MODEL_IDENTIFIER = 'MODELO';

export const fulfillmentTypes = {
	STORE: 'Store',
	DROPSHIP: 'Dropship',
	SPECIAL_ORDER: 'Special Order',
	ONLINE_ONLY: 'Online Only',
};

export const STORE_ONLY_AVAILABLE = 'STORE_ONLY_AVAILABLE';
export const STORE_BUYABLE_EXCLUDE = 'STORE_BUYABLE_EXCLUDE';
export const MARKET_BUYABLE_EXCLUDE = 'MARKET_BUYABLE_EXCLUDE';

export const PRODUCT = 'product';
export const MAX_QUANTITY_AVAILABLE = 999999999;
export const QUANTITY_AVAILABLE_PLUS_999 = 999;
export const QUANTITY_AVAILABLE_PLUS_199 = 199;
export const QUANTITY_AVAILABLE_PLUS_10 = 10;

export const LEAD_TIME_ADD_DEFAULT_DAYS = 2;

export const ICONS = {
	WISHLIST: 'favorite',
	RECENT_ORDERS: 'package_2',
	DEVICES: 'devices',
};

export const MATERIAL_SYMBOL_ICONS = {
	person: 'person',
	wishlist: 'wishlist',
	recentOrders: 'recentOrders',
	department: 'department',
	chevronLeft: 'chevronLeft',
	chevronRight: 'chevronRight',
	shoppingCart: 'shoppingCart',
	stacks: 'stacks',
	bolt: 'bolt',
	edit: 'edit',
	assignmentInd: 'assignmentInd',
	block: 'block',
	dangerous: 'dangerous',
	wallet: 'wallet',
	locationOn: 'locationOn',
	info: 'info',
	search: 'search',
	filterList: 'filterList',
	cancel: 'cancel',
	helpCenter: 'helpCenter',
	house: 'house',
	creditCard: 'creditCard',
	favorite: 'favorite',
	add: 'add',
	package: 'package',
	shoppingCartCheckout: 'shoppingCartCheckout',
	home: 'home',
	checkCircle: 'checkCircle',
	mail: 'mail',
	accountCircle: 'accountCircle',
	call: 'call',
	addCall: 'addCall',
	addLocationAlt: 'addLocationAlt',
	myLocation: 'myLocation',
	check: 'check',
	calendar: 'calendar',
	store: 'store',
	delete: 'delete',
	bopis: 'bopis',
	exclamation: 'exclamation',
	remove: 'remove',
	tune: 'tune',
	dashboardCustomize: 'dashboardCustomize',
	browse: 'browse',
	storefront: 'storefront',
	close: 'close',
	scene: 'scene',
	bathtub: 'bathtub',
	skillet: 'skillet',
	wallArt: 'wallArt',
	electricalServices: 'electricalServices',
	googleHomeDevices: 'googleHomeDevices',
	key: 'key',
	skull: 'skull',
	toolsPowerDrill: 'toolsPowerDrill',
	lightGroup: 'lightGroup',
	deceased: 'deceased',
	cleanHands: 'cleanHands',
	kitchen: 'kitchen',
	gardenCart: 'gardenCart',
	chair: 'chair',
	park: 'park',
	shelves: 'shelves',
	imagesearchRoller: 'imagesearchRoller',
	borderAll: 'borderAll',
	valve: 'valve',
	doorSliding: 'doorSliding',
	speedCamera: 'speedCamera',
	climateMiniSplit: 'climateMiniSplit',
	login: 'login',
	subdirectoryArrowRight: 'subdirectoryArrowRight',
	keyboardArrowRight: 'keyboardArrowRight',
	keyboardArrowLeft: 'keyboardArrowLeft',
	package2: 'package2',
	supervisedUserCircle: 'supervisedUserCircle',
	engineering: 'engineering',
	receiptLong: 'receiptLong',
	help: 'help',
	doorOpen: 'doorOpen',
	verified: 'verified',
	backspace: 'backspace',
	box: 'box',
	brightnessAlert: 'brightnessAlert',
	colors: 'colors',
	contentCopy: 'contentCopy',
	editSquare: 'editSquare',
	frameInspect: 'frameInspect',
	trolley: 'trolley',
	devices: 'devices',
	checkbox: 'checkbox',
	checkboxBlank: 'checkboxBlank',
	manageSearch: 'manageSearch',
	bookmarkHeart: 'bookmarkHeart',
	history: 'history',
	map: 'map',
	directions: 'directions',
	pinDrop: 'pinDrop',
	swapHoriz: 'swapHoriz',
	share: 'share',
	facebook: 'facebook',
	whatsapp: 'whatsapp',
	pinterest: 'pinterest',
	viewInAr: 'viewInAr',
	touchApp: 'touchApp',
	swipe: 'swipe',
	photoLibrary: 'photoLibrary',
	rotate360: 'rotate360',
	smartDisplay: 'smartDisplay',
	galleryThumbnail: 'galleryThumbnail',
	featuredSeasonalAndGifts: 'featuredSeasonalAndGifts',
	arrowForward: 'arrowForward',
	arrowDownward: 'arrowDownward',
	awardStar: 'awardStar',
	localActivity: 'localActivity',
	releaseAlert: 'releaseAlert',
	localShipping: 'localShipping',
	emergencyHome: 'emergencyHome',
	storePickup: 'storePickup',
	keyboardArrowDown: 'keyboardArrowDown',
	keyboardArrowUp: 'keyboardArrowUp',
	deck: 'deck',
} as const;

export enum OPEN_CLOSE_STATES {
	OPEN = 'open',
	CLOSE = 'close',
}

export const EDIT_ACTION = 'Editar';

export const CLOSE_STATE = 'close';
export const OPEN_STATE = 'open';

export const IMAGES = 'IMAGES';
export const MEDIA = 'MEDIA';

export const PRO_BOOST_BASE_URL = 'https://pro.homedepot.com.mx';

export const CUSTOM_BREAKPOINT_470 = 470;
export const CUSTOM_BREAKPOINT_570 = 570;
export const CUSTOM_BREAKPOINT_980 = 980;
export const CUSTOM_BREAKPOINT_1024 = 1024;

export const PASTELES_FAMILY_COLOR = 'Pasteles';

export const PRODUCT_SKU_STRING_PART = 'P';
export const PRODUCT_WITHOUT_PRICE = '0.0';
export const PRODUCT_MEASURE_M2 = 'm2';

export const PROTECTED_PAGES = ['/account'];

export enum PRODUCT_PRICE_USAGE {
	OFFER = 'Offer',
	DISPLAY = 'Display',
}
export enum PAGES_METADATA {
	HOMEPAGE = 'homepage',
	PDP = 'pdp',
}

export const ALLOWED_URL_PATTERNS = [
	/^\/$/,
	/^\/p\/.*/,
	/^\/HDM-B2C-Store\/p\/.*/,
	/^\/login(?:\/.*)?$/,
	/^\/signup(?:\/.*)?$/,
	/^\/cart(?:\/.*)?$/,
	/^\/checkout(?:\/.*)?$/,
	/^\/thank-you(?:\/.+)?$/,
	/^(?:\/account(?:\/(?:orders|addressbook))?|\/account\/order-details(?:\?(?=[^#]*\borderId=[^&#]+)[^#]*)?)$/,
	/^\/b(?:\/.*)?$/,
	/^\/g(?:\/.*)?$/,
	/^\/s(?:\/.*)?$/,
	/^\/compare-products(?:\/.*)?$/,
];
export const NOT_AVAILABLE_IMAGE = CDN_BASE_URL + '/assets/img/imagen-no-disponible.svg';

export const EMPTY_CARD_DATE = '  /  ';

export const ALPHABETIC_ALLOWED = /[^A-Za-zÝÉÝÓÚÜáéíóúüÑñ\s-]/g;
export const PHONE_REQUIRED_LENGTH = 10;
export const PHONE = 'phone' as const;
export const FIRST_NAME = 'firstName' as const;
export const LAST_NAME = 'lastName' as const;
export const COUNTRY_MX_CODE = '52';

export const RESPONSE_STATUS = {
	SUCCESS: 'Success',
} as const;

export const ERROR_FLEET = '_ERR_FLEET_DOWN';
export const ERROR_INVALID_MARKET = '_ERR_INVALID_MARKET';
export const ERROR_GENERIC = '_GENERIC_EXCEPTION';

export const SHIPPING_METHODS = {
	SPLIT: '3',
} as const;

export const DELIVERY_TYPES = {
	BOPIS: 'bopis',
	DELIVERY: 'delivery',
} as const;

export const SAME_DAY_DELIVERY_GROUP = 'SAME_DAY_DELIVERY';

export const IS_PARTNUMBER_FROM_BUNDLE_KEY = 'bundles';
export const STORE_CODE_SEARCH_PARAM = 'store_code';

export const GIFT_ITEM = 'Artículo de Regalo';

export const PAINT_COLOR_ROWS_MAX_QUANTITY = 11;

export const DEFAULT_PROFILE_NAME = 'HDMDEFAULT';

export const BULLET_POINT = '● ';

export const RESOLVED_MARKET_ID_PATTERN = /resolvedMarketId=(\d+)/;

export const DEFAULT_DELIVERY_ZIPCODE = '04870';
export const DEFAULT_DELIVERY_LOCALITY = 'México D.F.';
export const DEFAULT_DELIVERY_STATE = 'Ciudad de México';

export const ADDRESS_COMPONENT_TYPES = {
	POSTAL_CODE: 'postal_code',
	LOCALITY: 'locality',
	ADMIN_AREA_LEVEL_1: 'administrative_area_level_1',
} as const;
